import * as R from 'ramda';


export default function BulkDeleteReportInstancesDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  loaderService,
  ssDialogService,
  bulkDeleteReportInstancesConfirmDialog
) {
  const vm = this;
  
  vm.deleteIsSelected = false;
  vm.hasData = true;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleBulkDelete = _handleBulkDelete;
  vm.handleSelectAll = _handleSelectAll;

  /** ************************************************
   * Event Handlers
   */
  activate();

  function activate() {
    $scope.$on('selectBulkReportInstanceChange', () => {
      _handleSelectReportInstanceChange();
    });
  }

  function _handleBulkDelete($event) {
    const _ids = [];

    R.forEach((reportInstance) => {
      if (reportInstance.isBulkDelete) {
        _ids.push(reportInstance.reportInstanceId);
      }
    }, vm.reportInstances);

    ssDialogService.dialogs.reports.bulkDeleteReportInstancesConfirmDialog = ssDialogService.alert(
      bulkDeleteReportInstancesConfirmDialog.getOptions($event, {
        reportTypeId: vm.reportType.uniqueId,
        reportInstanceIds: _ids,
        updateCallBack: _broadcastEvents,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.reports.bulkDeleteReportInstancesConfirmDialog);
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.reports.bulkDeleteReportInstancesDialog);
  }

  function _handleSelectAll() {
    R.forEach((reportInstance) => {
      reportInstance.isBulkDelete = vm.selectAll;
      vm.deleteIsSelected = vm.selectAll;
    }, vm.reportInstances);
  }

  function _handleSelectReportInstanceChange() {
    const selectedIds = [];
    R.forEach((item) => {
      if (item.isBulkDelete === true) {
        selectedIds.push(item.reportInstanceId);
      }
    }, vm.reportInstances);
    vm.deleteIsSelected = selectedIds.length > 0;
    vm.selectAll = selectedIds.length === vm.reportInstances.length;
  }

  /** ************************************************
   * Private Functions
   */
  function _broadcastEvents() {
    $rootScope.$broadcast('refreshReportInstances', { reportType: vm.reportType });
  }
}

BulkDeleteReportInstancesDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'loaderService',
  'ssDialogService',
  'bulkDeleteReportInstancesConfirmDialog',
];
